import React, { memo } from 'react';
import styled from 'styled-components';

type ScanCheckInButtonsProps = {
	onComplete: () => void;
	onCancel: () => void;
};

// 체크인 확인 카드 하단 버튼 (체크인 완료 / 취소)
const ScanCheckInButtons = memo<ScanCheckInButtonsProps>(({ onComplete, onCancel }) => {
	return (
		<>
			<CompleteButton onClick={onComplete}>체크인 완료</CompleteButton>
			<CancelButton onClick={onCancel}>취소</CancelButton>
		</>
	);
});

ScanCheckInButtons.displayName = 'ScanCheckInButtons';

export default ScanCheckInButtons;

const BaseButton = styled.button`
	flex: 1;
	height: 60px;
	font-size: 16px;
	font-family: PretendardSemiBold, AppleSDGothicNeoSemiBold, sans-serif;
	border-radius: 6px;
	cursor: pointer;
	transition: 0.2s;
`;
const CompleteButton = styled(BaseButton)`
	color: ${({ theme }) => theme.colors.whiteColor};
	background-color: ${({ theme }) => theme.colors.activeBlue};

	&:hover {
		opacity: 0.9;
	}
`;
const CancelButton = styled(BaseButton)`
	color: ${({ theme }) => theme.colors.deepGrayFontColor};
	background-color: ${({ theme }) => theme.colors.whiteColor};

	&:hover {
		background-color: ${({ theme }) => theme.colors.lightGrayHoverColor};
	}
`;
